import styled, { css } from 'styled-components'
import { breakpoints, colors, fontSizes, transitions, fontWeights } from '@/styles'

const offsetX = 0
const offsetY = 16
const activeOffsetY = 3

export const active = `
  color: ${colors.black};
  transform: translate(${offsetX}px, ${activeOffsetY}px);
  font-size: 10px;
  line-height: 18px;
  font-weight: ${fontWeights.medium};
  svg {
    display: none;
  }
`

const medium = css`
  font-size: 14px;
  line-height: 18px;
`

const large = css`
  font-size: ${fontSizes.regular};
  line-height: 22px;
`

const responsive = css`
  ${medium}
  @media screen and (max-width: ${breakpoints.phoneMax}) {
    ${large}
  }
`

const getSize = (size?: string) => {
  if (size === 'responsive') return responsive
  if (size === 'medium') return medium
  return large
}

const Label = styled.label<{ x?: number; y?: number; hasError?: boolean; size?: string }>`
  transition: ${transitions.floatingLabel};
  position: absolute;
  display: flex;
  align-items: center;
  pointer-events: none;
  color: ${colors.foregroundTertiary};
  padding-left: 8px;
  top: 0;
  left: 0;
  ${props => `
    transform: translate(${props.x || offsetX}px, ${props.y || offsetY}px);
  `}
  ${props =>
    props.hasError &&
    `
    svg {
      path {
        fill: ${colors.red64}
      }
    }
  `}
  svg {
    margin-right: 6px;
  }
  ${props => getSize(props.size)}
`

export default Label
